import { CustomOrderType } from '../../carts/CustomOrderType';
import { RemoveDiscountCodeResult } from '../../../graphql/cart/removeDiscountCode';
import { createAction } from '@reduxjs/toolkit';

export interface ApiRemoveDiscountCodeRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly codeId: string;
  readonly parentActionId: number;
}

export const apiRemoveDiscountCodeRequestedType = 'api/cart/removeDiscountCode--requested';
export const apiRemoveDiscountCodeRequested = createAction<ApiRemoveDiscountCodeRequestedPayload>(
  apiRemoveDiscountCodeRequestedType
);

export type ApiRemoveDiscountCodeRequestedAction = ReturnType<
  typeof apiRemoveDiscountCodeRequested
>;

export interface ApiRemoveDiscountCodeSucceededPayload {
  readonly cartId: string;
  readonly result: RemoveDiscountCodeResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiRemoveDiscountCodeSucceededType = 'api/cart/removeDiscountCode--succeeded';
export const apiRemoveDiscountCodeSucceeded = createAction<ApiRemoveDiscountCodeSucceededPayload>(
  apiRemoveDiscountCodeSucceededType
);

export type ApiRemoveDiscountCodeSucceededAction = ReturnType<
  typeof apiRemoveDiscountCodeSucceeded
>;

export interface ApiRemoveDiscountCodeFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiRemoveDiscountCodeFailedType = 'api/cart/removeDiscountCode--failed';
export const apiRemoveDiscountCodeFailed = createAction<ApiRemoveDiscountCodeFailedPayload>(
  apiRemoveDiscountCodeFailedType
);
export type ApiRemoveDiscountCodeFailedAction = ReturnType<typeof apiRemoveDiscountCodeFailed>;
